import { X, Trash2, ShoppingCart, Minus, Plus } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";

const CartDrawer = ({ isOpen, onClose, cart, onRemoveItem, onCheckout }) => {
  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent className="bg-void-black border-l border-white/10 w-full sm:max-w-md p-0">
        {/* Header */}
        <SheetHeader className="p-6 border-b border-white/5">
          <SheetTitle className="font-orbitron text-white flex items-center gap-3">
            <ShoppingCart className="w-5 h-5 text-neon-blue" />
            YOUR CART
            <span className="bg-neon-pink text-white text-xs px-2 py-0.5 ml-auto">
              {cart.length} ITEMS
            </span>
          </SheetTitle>
        </SheetHeader>

        {/* Cart Items */}
        <div className="flex-1 overflow-y-auto p-6 space-y-4" style={{ maxHeight: 'calc(100vh - 250px)' }}>
          {cart.length === 0 ? (
            <div className="text-center py-12">
              <ShoppingCart className="w-16 h-16 text-gray-700 mx-auto mb-4" />
              <p className="font-rajdhani text-gray-500">Your cart is empty</p>
              <p className="font-rajdhani text-xs text-gray-600 mt-2">
                Add some gear to get started!
              </p>
            </div>
          ) : (
            cart.map((item) => (
              <div 
                key={item.cartId}
                className="cyber-card p-4 flex gap-4"
                data-testid={`cart-item-${item.cartId}`}
              >
                {/* Image */}
                <div className="w-20 h-20 flex-shrink-0 overflow-hidden">
                  <img 
                    src={item.image_url}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Details */}
                <div className="flex-1 min-w-0">
                  <h4 className="font-orbitron text-sm text-white uppercase truncate">
                    {item.name}
                  </h4>
                  <p className="font-rajdhani text-xs text-gray-500 mt-1">
                    {item.selectedSize} / {item.selectedColor}
                  </p>
                  <div className="flex items-center justify-between mt-2">
                    <span className="font-orbitron text-neon-blue">
                      ${item.price.toFixed(2)}
                    </span>
                    <button
                      onClick={() => onRemoveItem(item.cartId)}
                      className="text-gray-500 hover:text-neon-pink transition-colors"
                      data-testid={`cart-remove-${item.cartId}`}
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Footer */}
        {cart.length > 0 && (
          <div className="border-t border-white/5 p-6 space-y-4">
            {/* Total */}
            <div className="flex items-center justify-between">
              <span className="font-orbitron text-gray-400 uppercase">Total</span>
              <span className="font-orbitron text-2xl text-white">
                ${total.toFixed(2)}
              </span>
            </div>

            {/* Checkout Button */}
            <button
              onClick={onCheckout}
              className="w-full cyber-btn cyber-btn-pink pulse-glow"
              data-testid="cart-checkout-btn"
            >
              <span>CHECKOUT</span>
            </button>

            <p className="font-rajdhani text-xs text-center text-gray-600">
              Secure payment powered by Stripe
            </p>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};

export default CartDrawer;
